<template>
    <div class="container-fluid pt-3">
        <div class="certificate-wrapper mb-3" ref="wrapper">
            <div style="font-family: PressStart;"></div>
            <canvas
                ref="canvas"
                :style="{ visibility: loading ? 'hidden' : 'visible' }"
            ></canvas>
            <div class="preload-font1">Noto Sans HK</div>
            <div class="preload-font2">Noto Sans HK</div>
        </div>
        <div class="row form-row mb-2">
            <div class="col-6">
                <button class="btn btn-more w-100" @click="share">
                    分享至信箱
                </button>
            </div>
            <div class="col-6">
                <button class="btn btn-more w-100" @click="downLoad">
                    證書儲存
                </button>
            </div>
        </div>
        <button class="btn btn-danger w-100 mb-3" @click="cancel">結束</button>
        <div
            class="modal modal-confirm fade"
            ref="modal"
            tabindex="-1"
            aria-hidden="true"
        >
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            通知
                        </h5>
                    </div>
                    <div class="modal-body">
                        <label for="detail_to_email"
                            >請問要分享至您的信箱嗎?</label
                        >
                        <input
                            type="email"
                            class="form-control"
                            id="detail_to_email"
                            v-model="detail.toMail"
                            placeholder="請輸入您的信箱"
                        />
                    </div>
                    <div class="modal-footer">
                        <div class="btn-group">
                            <button
                                type="button"
                                class="btn btn-close"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                取消
                            </button>
                            <button
                                type="button"
                                class="btn btn-ok"
                                @click="sendMail"
                            >
                                立即分享
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import coreMixin from '@/js/mixin/coreMixin';
import { apiPostCollectionSendGmail } from '@/plugin/api';
import { GET_PHOTO } from '@/plugin/api/constants';

export default {
    data() {
        return {
            detail: {
                toEmail: '',
                name: this.$route.query.name,
            },
            nameY: 350,
            dateY: 700,
            nameFontSize: 78,
            dateFontSize: 29,
            loading: true,
        };
    },
    async mounted() {
        document.querySelector('body').appendChild(this.$refs.modal);

        await this.generateCertificate(this.$refs.canvas);
        this.loading = false;
    },
    beforeDestroy() {
        document.querySelector('body').removeChild(this.$refs.modal);
    },
    computed: {
        isMobile() {
            const toMatch = [
                /Android/i,
                /webOS/i,
                /iPhone/i,
                /iPad/i,
                /iPod/i,
                /BlackBerry/i,
                /Windows Phone/i,
            ];

            return toMatch.some((toMatchItem) => navigator.userAgent.match(toMatchItem));
        },
    },
    methods: {
        /**
         * 產生證書
         * @param {Element} canvas 畫布元素
         * @param {Number} nameY 姓名Y軸位置
         * @param {Number} dateY 日期Y軸位置
         */
        async generateCertificate(canvas) {
            const src = this.getPhoto(this.$route.query.photoId);
            this.setLoading(true);
            const image = await this.getImage(src);
            // 加入底圖圖片
            await this.drawImage(canvas, image, image.width, image.height);
            // 加入文字資訊
            await this.addInfo(
                canvas,
                this.nameY,
                this.dateY,
                this.nameFontSize,
                this.dateFontSize,
            );
            this.setLoading(false);
            canvas.style.width = '100%';
        },
        /**
         * 取得圖片位址
         * @param {String} id 圖片id
         */
        getPhoto(id) {
            return `${process.env.VUE_APP_API + GET_PHOTO}/ori/${id}`;
        },
        /**
         * 取得圖片物件
         * @param {String} src 圖片位址
         */
        getImage(src) {
            return new Promise((resolve, reject) => {
                const image = new Image();
                image.crossOrigin = 'anonymous';
                image.onload = () => resolve(image);
                image.onerror = (error) => reject(error);
                image.src = src;
            });
        },
        /**
         * 畫入圖片
         * @param {Element} canvas 畫布元素
         * @param {Image} image 圖片
         * @param {Number} width 寬度
         * @param {Number} height 高度
         */
        async drawImage(canvas, image, width, height) {
            const context = canvas.getContext('2d');
            canvas.width = width;
            canvas.height = height;
            context.drawImage(image, 0, 0, width, height);
        },
        /**
         * 字體載入
         */
        fontLoaded() {
            const vm = this;
            return new Promise((resolve) => {
                // eslint-disable-next-line consistent-return
                setTimeout(() => {
                    if (
                        document.fonts.check(
                            `500 ${this.nameFontSize}px source-han-sans-traditional`,
                        )
                    ) {
                        resolve();
                    } else {
                        return vm.fontLoaded();
                    }
                }, 1000);
            });
        },
        /**
         * 加入文字
         * @param {Object} context canvas物件
         * @param {String} text 文字
         * @param {String} fontSize 文字大小
         * @param {Number} fontWeight 文字粗細
         * @param {Number} x x軸座標
         * @param {Number} y y軸座標
         */
        drawText(context, text, fontSize, fontWeight, x, y) {
            context.font = `${fontWeight} ${fontSize} source-han-sans-traditional`;
            context.fillStyle = '#06561E';
            context.textAlign = 'center';
            context.fillText(text, x, y);
        },

        /**
         * 產生證書
         * @param {Element} canvas 畫布元素
         * @param {Number} nameY 姓名Y軸位置
         * @param {Number} dateY 日期Y軸位置
         * @param {Number} nameFontSize 姓名字體大小
         * @param {Number} dateFontSize 日期字體大小
         */
        async addInfo(canvas, nameY, dateY, nameFontSize, dateFontSize) {
            const vm = this;
            const context = canvas.getContext('2d');
            function addName(fontSize, y) {
                vm.drawText(
                    context,
                    vm.$route.query.name,
                    `${fontSize}px`,
                    500,
                    canvas.offsetWidth / 2,
                    y,
                );
            }
            function addDate(fontSize, y) {
                vm.drawText(
                    context,
                    `完成日期:${vm.dateConvert(new Date(), 'YYYYMMDD')}`,
                    `${fontSize}px`,
                    400,
                    canvas.offsetWidth / 2,
                    y,
                );
            }

            // 等待字體載入
            await this.fontLoaded();
            // 加入姓名
            addName(nameFontSize, nameY);
            // 加入日期
            addDate(dateFontSize, dateY);
        },
        /**
         * 下載圖片
         */
        downLoad() {
            if (this.isMobile) {
                const image = new Image();

                image.src = this.$refs.canvas.toDataURL();

                const w = window.open('');
                w.document.head.insertAdjacentHTML(
                    'beforeend',
                    '<meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1.0, user-scalable=no">',
                );
                w.document.write(
                    `<p style="font-size:2rem;">長按圖片下載</p>${image.outerHTML}`,
                );
                return;
            }
            const link = document.createElement('a');
            link.download = '川柳不息知識王.png';
            link.href = this.$refs.canvas.toDataURL();
            link.click();
            this.commonConfirm('你的證書已儲存到手機', () => {}, false, '確認');
        },
        /**
         * 結束按鈕
         */
        cancel() {
            this.commonConfirm(
                '提醒您將證書儲存至手機，證書兌換完成後即無法再次兌換。',
                () => {
                    // 有按下結束才當作已兌換過
                    localStorage.setItem(
                        `${this.$route.params?.id}_is_exchange`,
                        JSON.stringify(true),
                    );
                    this.$router.push('/campaign');
                },
                true,
                '已儲存',
            );
        },
        /**
         * 開啟分享視窗
         */
        share() {
            $(this.$refs.modal).modal('show');
        },
        /**
         * 將畫布元素變為Blob
         * @param {Element} canvas 畫布元素
         */
        createFile(canvas) {
            const dataURL = canvas.toDataURL('image/png');
            const blobBin = atob(dataURL.split(',')[1]);
            const array = [];
            // eslint-disable-next-line no-plusplus
            for (let i = 0; i < blobBin.length; i++) {
                array.push(blobBin.charCodeAt(i));
            }

            return new Blob([new Uint8Array(array)], {
                type: 'image/png',
            });
        },
        /**
         * 寄送信件
         */
        sendMail() {
            if (!this.detail.toMail) {
                this.commonConfirm('您未輸入電子郵件，請確認。');
                return;
            }
            const file = this.createFile(this.$refs.canvas);
            const body = new FormData();
            body.append('file', file, '證書.png');
            this.setLoading(true);
            apiPostCollectionSendGmail(body, this.detail).then((ret) => {
                if (ret.data.success) {
                    this.commonConfirm(
                        '已發送至您輸入的信箱，請至信箱查看，謝謝!',
                        () => {
                            $(this.$refs.modal).modal('hide');
                        },
                    );
                } else {
                    this.commonAlert(ret.data.message);
                }
                this.setLoading(false);
            });
        },
    },
    mixins: [coreMixin],
    beforeRouteEnter(to, from, next) {
        // 驗證是否已兌換，若否導回活動列表
        if (JSON.parse(localStorage.getItem(`${to.params?.id}_is_exchange`))) {
            next('/campaign');
        } else {
            next();
        }
    },
};
</script>

<style></style>
